module.exports = __webpack_public_path__ + "img/s6Icon5.3ba0472b.png";